module.exports = __webpack_public_path__ + "img/scan (11).2ca07f28.jpg";